// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "a.add-channel[data-v-41b38cda]{display:flex;align-items:center;border-bottom:none;padding:10px}.add-circle[data-v-41b38cda]{margin-right:10px;display:grid;align-items:center;justify-content:center;width:19px;height:19px;box-shadow:0 2px 4px 1px rgba(0,0,0,.12);border-radius:50%;border:4px solid #1680f0}", ""]);
// Exports
module.exports = exports;
